import React from 'react';
import PropTypes from 'prop-types';

import { Text } from './style';

const Email = ({ value }) => (
  <Text>{value}</Text>
);
Email.propTypes = {
  original: PropTypes.shape({
    email: PropTypes.string,
  }),
  value: PropTypes.string,
};
Email.defaultProps = {
  original: {},
  value   : '',
};

export default Email;
